import SSPMissionCommonChildrens from "@/router/common-routes/mission/children/mission-common-childrens";

export default [...SSPMissionCommonChildrens];
